function createElement(tag, options = {}) {
  const el = document.createElement(tag)
  const allowedOptions = ['className', 'innerText', 'src', 'alt', 'id', 'innerHTML', 'href', 'onclick', 'target']
  allowedOptions.forEach((key) => {
    if (options[key]) el[key] = options[key]
  })
  return el
}

function getUrlFallback(params){
  //todo change this weird hash
  return "haa5d71fcb167ad735460d9053234afd9e://nuapp.nubank.com.br/bdc/nuid-bdc/expr/sso" + params.toString()
}

function createGoToApp(id, idButton, params) {
  const goToAppContainer = document.getElementById(id)
  const anchor = createElement('a', {
    id: idButton,
    innerText: 'Abrir app do Nubank',
    href: getUrlFallback(params),
    target: '_blank',
    onclick: () => amplitude.getInstance().logEvent('button__clicked', Object.assign(eventProps, {'entity_name': 'go_to_app'})),
  })
  goToAppContainer.appendChild(anchor)
}

function dec2hex(dec) {
  return dec.toString(36).padStart(2, "0")
}

function generateID(len) {
  var arr = new Uint8Array((len || 64) / 2)
  window.crypto.getRandomValues(arr)
  return Array.from(arr, dec2hex).join('')
}

function startPooling(domain, flow, params, maxPoolingTime) {
    const int = setInterval(async () => {
        const response = await fetch(`${domain}/api/oauth2/flow/redirect?flow=${flow}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Correlation-ID': 'Oauth2Web',
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        }).then(resp => resp.json())

        if(response.redirect_uri) {
            window.location.assign(response.redirect_uri + "&state=" + params.state)
        }

    }, 2000)

    setTimeout(() => clearInterval(int), maxPoolingTime)
}

async function postParams(domain, params) {
    return fetch(`${domain}/api/oauth2/sso`, {
        method: "POST",
        mode: 'cors',
        body: JSON.stringify(params),
        headers: {
            'X-Correlation-ID': 'Oauth2Web',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(res => res.json())
      .then(data => data['sso_id'])
}

module.exports = {
    createGoToApp,
    generateID,
    startPooling,
    postParams
}
